module.exports = __webpack_public_path__ + "static/affiliates_hero-ab0f1aaa86bd6ac63450bc82bad575ae.png";